import React from 'react';

import GenerateGiftCode from '@src/api/GeneratePrimeGiftCode';
import { generateDiscount } from '@src/factories';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import { Discount } from '@src/types';

import useAuthenticationTokens from './useAuthenticationTokens';

const usePrimeDiscountCode = () => {
  const {
    tokens: { userID, accessToken },
  } = useAuthenticationTokens();
  const axiosRequestConfig = useAxiosRequestConfig();
  const [loading, setLoading] = React.useState(false);
  const [discount, setDiscount] = React.useState<Discount>();

  const makeRequest = React.useCallback(async () => {
    if (!userID || !accessToken) {
      return;
    }
    setLoading(true);
    try {
      const response = await GenerateGiftCode(accessToken, axiosRequestConfig);
      setDiscount(generateDiscount(response.data.discount));
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [accessToken, axiosRequestConfig, userID]);

  return React.useMemo(() => ({ discount, makeRequest, loading }), [
    discount,
    makeRequest,
    loading,
  ]);
};

export default usePrimeDiscountCode;
